import { filtersList } from "@utils/inbox"
import { useInboxStore } from "stores/inboxStore"
import { FilterListItem } from "types/inbox"

import Item from "./Item"
import Search from "./Search"
import SegToggle from "@components/SegToggle"

const Tabs = () => {
  const totalCount = useInboxStore(state => state.pagination.total)
  const currentOpenTab = useInboxStore(state => state.currentOpenTab)
  const setCurrentOpenTab = useInboxStore(state => state.setCurrentOpenTab)
  const viewMode = useInboxStore(state => state.viewMode)
  const setViewMode = useInboxStore(state => state.setViewMode)
  const isLoading = useInboxStore(state => state.isLoading)

  return (
    <div className="md:m-6 md:mb-2 inline-flex xs:w-[100vw] md:w-[calc(100%-50px)] flex-col items-start justify-start gap-3 px-6 pt-4">
      <Search />

      <div className="flex w-full items-center justify-between gap-3">
        <div className="inline-flex gap-1 overflow-auto rounded-full border border-[#E6EBF3] bg-white p-[3px] xs:max-w-[100vw] md:max-w-[58vw] xs:ml-[-20px] md:ml-0">
          {filtersList.map(filter => (
            <Item
              key={filter.value}
              title={filter.title}
              active={filter.title === currentOpenTab.title}
              paginationCount={isLoading ? "" : totalCount}
              onClick={() => setCurrentOpenTab(filter)}
            />
          ))}
        </div>
        {/* wave4-fix6: Ale's Grid|List toggle (her .seg treatment).
            PEOPLE-ALIGN 2026-07-03: now the shared @components/SegToggle -- People reuses the
            identical component for its List|Grid|Network|Map toggle. */}
        <SegToggle
          testId="inbox-view-toggle"
          value={viewMode}
          onChange={setViewMode}
          options={[
            { value: "grid", label: "Grid", testId: "inbox-view-grid" },
            { value: "list", label: "List", testId: "inbox-view-list" },
          ]}
        />
      </div>
    </div>
  )
}

export default Tabs
